module.exports = __webpack_public_path__ + "static/img/home_content_2.beda10a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/home_content_2.png
// module id = IOyg
// module chunks = 1